import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary:', error, errorInfo);
  }
  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: 32, textAlign: 'center' }}>
          <h2>Ocurrió un error en el panel. Por favor recarga la página.</h2>
          <p style={{ color: '#8392a5', fontSize: 13 }}>Si persiste, limpia caché (Ctrl+F5).</p>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
